import {
    DAYLIGHT_MARK_CODE_COMPLETE,
    DAYLIGHT_UNMARK_CODE_COMPLETE,
    DAYLIGHT_MARK_CODE_MAPPING_FOR_REVIEW,
    DAYLIGHT_REMOVE_CODE_MAPPING,
    DAYLIGHT_UNMARK_CODE_MAPPING_FOR_REVIEW,
    SET_DAYLIGHT_CODES,
    SET_INCOMING_NEO_CODES,
    SET_NEO_CODES,
    TOGGLE_DAYLIGHT_CODE_REVIEW_MODAL,
    SET_DAYLIGHT_WORKING_PRACTICE,
    SET_DAYLIGHT_IS_LOADING_CODES,
    SET_DAYLIGHT_PRACTICE_FINALIZED_STATUS,
    SET_DAYLIGHT_CODES_FILTER_CODE_NAME,
    SET_DAYLIGHT_CODES_FILTER_CODE_CATEGORY,
    SET_DAYLIGHT_CODES_FILTER_CODE_DESCRIPTION,
    SET_DAYLIGHT_CODES_FILTER_CODE_MAPPING,
    SET_DAYLIGHT_CODES_FILTER_CODE_HAS_COMMENTS,
    SET_DAYLIGHT_CODES_FILTER_CODE_IS_MARKED_COMPLETED,
    SET_DAYLIGHT_CODES_FILTER_CODE_NEEDS_REVIEW,
    SET_DAYLIGHT_CODES_FILTER_MARKED_DISABLED,
    SET_DAYLIGHT_CODES_FILTER_CODE_LOCATION,
    SET_DAYLIGHT_UPDATING_CODE_ID,
    SET_DAYLIGHT_UPDATING_MAPPING_ID,
    SET_DAYLIGHT_TARGET_CODE_FOR_ACTION,
    SET_DAYLIGHT_ADD_MAPPING_MODAL_OPEN,
    SET_DAYLIGHT_EDIT_MAPPING_MODAL_OPEN,
    SET_DAYLIGHT_TARGET_MAPPING_FOR_ACTION,
    SET_DAYLIGHT_SELECTED_CODE_USAGE_DETAIL,
    SET_DAYLIGHT_USER_HAS_ACCESS_TO_USAGE_DETAILS,
    SET_DAYLIGHT_MAPPING_COMMENT_MODAL_OPEN,
    SET_DAYLIGHT_MAPPING,
    SET_DAYLIGHT_MAPPING_COMMENT,
    SET_DAYLIGHT_CODES_DISPLAYED_COUNT,
    ADD_DAYLIGHT_MAPPING,
    SET_DAYLIGHT_CODE,
    SET_DAYLIGHT_SELECTED_PARTNER_ID,
} from '../ActionTypes';

const initialState = {
    practiceIsFinalized: false,
    daylightCodes: [],
    daylightCodeCount: 0,
    daylightTotalCodesCount: 0,
    daylightCodeCategories: [],
    daylightLocations: [],
    incomingNeoCodes: [],
    neoCodes: [],
    daylightCodeModalVisible: false,
    practice: { id: '', name: '' },
    isLoadingCodes: false,
    codeNameFilter: '',
    codeCategoryFilter: '',
    codeDescriptionFilter: '',
    codeLocationFilter: '',
    codeMappingFilter: '',
    codeHasCommentsFilter: null,
    codeIsMarkedCompletedFilter: null,
    codeNeedsReviewFilter: null,
    codeMarkedDisabledFilter: null,
    actionTargetCode: {},
    updatingCodeId: '',
    updatingMappingId: '',
    actionTargetMapping: {},
    isAddMappingModalOpen: false,
    isEditMappingModalOpen: false,
    selectedCodeUsageDetail: 'frequency6Month',
    userHasAccessToCodeUsageDetails: false,
    isMappingCommentModalOpen: false,
    partnerIdFilter: null,
};

const daylightReduction = (state = initialState, action) => {
    switch (action.type) {
        case SET_DAYLIGHT_WORKING_PRACTICE:
            return {
                ...state,
                practice: action.payload,
            };
        case SET_DAYLIGHT_UPDATING_CODE_ID:
            return {
                ...state,
                updatingCodeId: action.payload,
            };
        case SET_DAYLIGHT_UPDATING_MAPPING_ID:
            return {
                ...state,
                updatingMappingId: action.payload,
            };
        case TOGGLE_DAYLIGHT_CODE_REVIEW_MODAL:
            return {
                ...state,
                daylightCodeModalVisible: action.status,
            };
        case DAYLIGHT_MARK_CODE_MAPPING_FOR_REVIEW: {
            return {
                ...state,
                daylightCodes: state.daylightCodes.map((code) => {
                    if (code.id === action.targetCodeId) {
                        return { ...code, needsReview: true };
                    }
                    return code;
                }),
            };
        }
        case DAYLIGHT_UNMARK_CODE_MAPPING_FOR_REVIEW: {
            return {
                ...state,
                daylightCodes: state.daylightCodes.map((code) => {
                    if (code.id === action.targetCodeId) {
                        return { ...code, needsReview: false };
                    }
                    return code;
                }),
            };
        }
        case DAYLIGHT_REMOVE_CODE_MAPPING: {
            let newCode = {
                ...action.targetCode,
                mappings: action.targetCode.mappings.filter(
                    (mapping) => mapping.id !== action.targetMapping.id
                ),
            };
            return {
                ...state,
                daylightCodes: state.daylightCodes.map((code) => {
                    if (code.id === action.targetCode?.id) {
                        console.log('Removing mapping:', action.targetMapping);
                        return newCode;
                    }
                    return code;
                }),
            };
        }
        case DAYLIGHT_MARK_CODE_COMPLETE: {
            return {
                ...state,
                daylightCodes: state.daylightCodes.map((code) => {
                    if (code.id === action.targetCodeId) {
                        return { ...code, confirmationStatus: 1 };
                    }
                    return code;
                }),
            };
        }
        case DAYLIGHT_UNMARK_CODE_COMPLETE: {
            return {
                ...state,
                daylightCodes: state.daylightCodes.map((code) => {
                    if (code.id === action.targetCodeId) {
                        return { ...code, confirmationStatus: 0 };
                    }
                    return code;
                }),
            };
        }
        // TODO: not pure
        case SET_DAYLIGHT_CODES:
            return {
                ...state,
                practiceIsFinalized: action.codes?.isFinalized || false,
                daylightCodes: action.codes?.codeMappings || [],
                daylightTotalCodesCount: action.codes?.totalCount || 0,
                daylightCodeCategories: action.codes?.categories || [],
                daylightLocations: action.codes?.locations || [],
            };
        case SET_NEO_CODES:
            return {
                ...state,
                neoCodes: action.codes || [],
            };
        case SET_INCOMING_NEO_CODES:
            return {
                ...state,
                incomingNeoCodes: action.codes || [],
            };
        case SET_DAYLIGHT_PRACTICE_FINALIZED_STATUS:
            return {
                ...state,
                practiceIsFinalized: action.payload,
            };
        case SET_DAYLIGHT_IS_LOADING_CODES:
            return {
                ...state,
                isLoadingCodes: action.payload,
            };
        case SET_DAYLIGHT_CODES_FILTER_CODE_NAME:
            return {
                ...state,
                codeNameFilter: action.payload,
            };
        case SET_DAYLIGHT_CODES_FILTER_CODE_CATEGORY:
            return {
                ...state,
                codeCategoryFilter: action.payload,
            };
        case SET_DAYLIGHT_CODES_FILTER_CODE_DESCRIPTION:
            return {
                ...state,
                codeDescriptionFilter: action.payload,
            };
        case SET_DAYLIGHT_CODES_FILTER_CODE_MAPPING:
            return {
                ...state,
                codeMappingFilter: action.payload,
            };
        case SET_DAYLIGHT_CODES_FILTER_CODE_HAS_COMMENTS:
            return {
                ...state,
                codeHasCommentsFilter: action.payload,
            };
        case SET_DAYLIGHT_CODES_FILTER_CODE_IS_MARKED_COMPLETED:
            return {
                ...state,
                codeIsMarkedCompletedFilter: action.payload,
            };
        case SET_DAYLIGHT_CODES_FILTER_CODE_NEEDS_REVIEW:
            return {
                ...state,
                codeNeedsReviewFilter: action.payload,
            };
        case SET_DAYLIGHT_CODES_FILTER_MARKED_DISABLED:
            return {
                ...state,
                codeMarkedDisabledFilter: action.payload,
            };
        case SET_DAYLIGHT_CODES_FILTER_CODE_LOCATION:
            return {
                ...state,
                codeLocationFilter: action.payload,
            };
        case SET_DAYLIGHT_TARGET_CODE_FOR_ACTION:
            return {
                ...state,
                actionTargetCode: action.payload,
            };
        case SET_DAYLIGHT_ADD_MAPPING_MODAL_OPEN:
            return {
                ...state,
                isAddMappingModalOpen: action.payload,
            };
        case SET_DAYLIGHT_EDIT_MAPPING_MODAL_OPEN:
            return {
                ...state,
                isEditMappingModalOpen: action.payload,
            };
        case SET_DAYLIGHT_TARGET_MAPPING_FOR_ACTION:
            return {
                ...state,
                actionTargetMapping: action.payload,
            };
        case SET_DAYLIGHT_SELECTED_CODE_USAGE_DETAIL:
            return {
                ...state,
                selectedCodeUsageDetail: action.payload,
            };
        case SET_DAYLIGHT_USER_HAS_ACCESS_TO_USAGE_DETAILS:
            return {
                ...state,
                userHasAccessToCodeUsageDetails: action.payload,
            };
        case SET_DAYLIGHT_MAPPING_COMMENT_MODAL_OPEN:
            return {
                ...state,
                isMappingCommentModalOpen: action.payload,
            };
        case ADD_DAYLIGHT_MAPPING:
            return {
                ...state,
                daylightCodes: state.daylightCodes.map((code) => {
                    if (code.id === action.targetCodeId) {
                        return {
                            ...code,
                            mappings: [...code.mappings, action.payload],
                        };
                    }
                    return code;
                }),
            };
        case SET_DAYLIGHT_MAPPING:
            return {
                ...state,
                daylightCodes: state.daylightCodes.map((code) => {
                    if (code.id === action.targetCodeId) {
                        return {
                            ...code,
                            mappings: code.mappings.map((mapping) => {
                                if (
                                    mapping.taxonomyCodeNodeGuid ===
                                    action.payload.oldTaxonomyCodeNodeGuid
                                ) {
                                    return {
                                        ...mapping,
                                        ...action.payload,
                                    };
                                }
                                return mapping;
                            }),
                        };
                    }
                    return code;
                }),
            };
        case SET_DAYLIGHT_MAPPING_COMMENT:
            return {
                ...state,
                daylightCodes: state.daylightCodes.map((code) => {
                    if (code.id === action.targetCodeId) {
                        return {
                            ...code,
                            mappings: code.mappings.map((mapping) => {
                                if (mapping.id === action.targetMappingId) {
                                    return {
                                        ...mapping,
                                        comments: action.payload,
                                    };
                                }
                                return mapping;
                            }),
                        };
                    }
                    return code;
                }),
            };
        case SET_DAYLIGHT_CODES_DISPLAYED_COUNT:
            return {
                ...state,
                daylightCodeCount: action.payload,
            };
        case SET_DAYLIGHT_CODE:
            return {
                ...state,
                daylightCodes: state.daylightCodes.map((code) => {
                    if (code.id === action.payload.id) {
                        return action.payload;
                    }
                    return code;
                }),
            };
        case SET_DAYLIGHT_SELECTED_PARTNER_ID:
            return {
                ...state,
                partnerIdFilter: action.payload,
            };
        default:
            return state;
    }
};

export default daylightReduction;
